import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { TranslateModule as NgXTranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [HttpClientModule, NgXTranslateModule],
})
export class TranslateModule {}
